module.exports = __webpack_public_path__ + "img/pin1.78eb1895.svg";